// Main component
export { DataTable } from "./data-table";
export { DataTableEmptyCell } from "./data-table-empty-cell";

// Sub-components (for advanced customization)
export { DataTableHeader } from "./data-table-header";
export { DataTableRowComponent } from "./data-table-row";
export { DataTablePagination } from "./data-table-pagination";
export { DataTableFilterBar } from "./data-table-filter-bar";
export { DataTableColumnVisibility, hasHideableColumns } from "./data-table-column-visibility";
export type { DataTableColumnVisibilityProps } from "./data-table-column-visibility";
export { DataTableBulkActions } from "./data-table-bulk-actions";
export { DataTableEmptyState, DataTableLoadingRows } from "./data-table-empty-state";

// Hook
export { useDataTable } from "./use-data-table";
export type { UseDataTableOptions } from "./use-data-table";
export { useDataTablePersistence } from "./use-data-table-persistence";
export type {
  DataTableFilterSelection,
  DataTablePersistedSection,
  DataTablePersistedState,
  UseDataTablePersistenceOptions,
  UseDataTablePersistenceResult,
} from "./use-data-table-persistence";

// Types
export * from "./data-table.types";

// Test utilities
export * from "./data-table.utils";
